export default {"src":"/_next/static/media/elment4.b02223f9.svg","height":62,"width":91,"blurWidth":0,"blurHeight":0};